export const MODE = {
  EDIT: 'edit',
  BROWSE: 'browse'
};



/** WEBPACK FOOTER **
 ** ./src/constants/mode.js
 **/